import { css } from 'styled-components';

const outlineBase = css`
  outline-color: transparent;
  outline-offset: ${({ theme })=>`${theme.outline.offset}px`};
  outline-style: ${({ theme })=>theme.outline.style};
  outline-width: ${({ theme })=>`${theme.outline.width}px`};
`;

export { outlineBase };
//# sourceMappingURL=outline.js.map
